// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:00:37

export default {
  "id": "money-ping-pong",
  "slug": "money-ping-pong",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/02ca8022d7c34d079271f088f50e5265-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/02ca8022d7c34d079271f088f50e5265/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Money ping pong",
      "description": "Money ping pong is a casual idle game where you need to deftly install money blocks, use them to reduce the space for balls and earn money faster and more money!\n\nThere are many different maps\nand dozens of functional blocks\nRelaxing gameplay",
      "instructions": "Place money blocks on the field to create your own pinball strategy for making money. Buy upgrades to complete the level.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "idle",
        "logical",
        "manager",
        "pingpong",
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "金钱乒乓",
      "description": "金钱乒乓是一款休闲挂机游戏，你需要灵巧地安装金钱方块，利用它们来减少球的空间，更快地赚取更多金钱！\n\n游戏中有许多不同的地图\n和数十种功能性方块\n轻松的游戏玩法",
      "instructions": "在场上放置钱块，创建自己的赚钱弹球策略。购买升级来完成关卡。",
      "genres": [
        "拼图"
      ],
      "tags": [
        "空闲",
        "逻辑",
        "经理",
        "乒乓球",
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "錢幣乒乓",
      "description": "錢錘乒乓是一款輕鬆的休閒遊戲，您需要靈巧地安裝錢塊，利用它們來減少球體的空間，並更快、獲得更多金錢！\n\n有許多不同的地圖\n和數十種功能塊\n放鬆的遊戲玩法",
      "instructions": "在場地上放置錢塊，以建立您自己的針球策略來賺錢。購買升級來完成等級。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "閒暇",
        "邏輯",
        "經理",
        "乒乓球",
        "時間消磨者"
      ]
    },
    "zh-HK": {
      "title": "錢錘乒乓球",
      "description": "錢錘乒乓球是一款輕鬆的閒置遊戲，你需要靈巧地安裝錢塊，用它們來縮小球體的空間，並更快、更多錢地賺錢！\n\n有許多不同的地圖\n以及數十種功能塊\n輕鬆遊戲體驗",
      "instructions": "將錢塊放置於場地，以創造屬於自己的搖搖樂策略，賺取金錢。購買升級來完成關卡。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "閒置",
        "邏輯",
        "經理",
        "乒乓球",
        "時間消磨者"
      ]
    },
    "ja": {
      "title": "マネーピンポン",
      "description": "マネーピンポンは、軽いインディー idle ゲームで、金のブロックを巧みに配置し、それを使ってボールのスペースを減らし、より速くもっとお金を稼ぐ必要があります！\n\nさまざまなマップが多く、機能するブロックが数十種類あります\nリラックスできるゲームプレイ",
      "instructions": "フィールドに金のブロックを配置し、自分自身のピンボール戦略を作成してお金を稼ぎましょう。レベルをクリアするためにアップグレードを購入してください。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "アイドル",
        "論理的",
        "マネージャー",
        "ピンポン",
        "時間の殺し手"
      ]
    },
    "ko": {
      "title": "머니 핑pong",
      "description": "머니 핑pong은 돈 블록을 마스터적으로 설치하고, 이를 사용하여 공의 공간을 줄여 더 빠르게 더 많은 돈을 벌 수 있는 캐주얼 아이들 게임입니다!\n\n다양한 맵과 수십 가지 기능 블록이 있습니다\n 편안한 게임 플레이",
      "instructions": "장을에 돈 블록을 배치하여 독자적인 핀볼 전략을 통해 돈을 벌세요. 레벨을 완료하기 위해 업그레이드를 구매하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "idle: 라이드\nlogical: 논리적\nmanager: 매니저\npingpong: 핑pong\ntimekiller: 시간소비자"
      ]
    },
    "fr": {
      "title": "Ping-pong financier",
      "description": "Money ping pong est un jeu casual idle où il faut habilement installer des blocs d'argent, les utiliser pour réduire l'espace pour les balles et gagner plus d'argent plus rapidement !\n\nIl y a de nombreux différents cartes\net des dizaines de blocs fonctionnels\nJeu de relaxation",
      "instructions": "Placez des blocs monétaires sur le champ pour créer votre propre stratégie de flipper pour gagner de l'argent. Achetez des améliorations pour terminer le niveau.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "paresseux",
        "logique",
        "gestionnaire",
        "pingpong",
        "tueur de temps"
      ]
    }
  }
};
